import { SECTION_TWO_TYPING_LABEL } from "./chat-transcript";

/** Bare typing label — rendered inside the assistant turn so the avatar stays mounted. */
export function ChatTypingIndicator() {
	return <p className="m-0 text-[13px] font-medium tracking-[-0.01em] text-grey-1000">{SECTION_TWO_TYPING_LABEL}</p>;
}
